<template>
  <div id="app">
    <zaheader></zaheader>
    <router-view/>
    <zafooter :dados="siteConfig"></zafooter>
  </div>
</template>


<script>
import zaheader from "./layout/Header.vue";
import zafooter from "./layout/Footer.vue";
import {siteConfig} from "./dados.js"
export default {
  data() {
    return {
       siteConfig
    };
  },
  name: "App",
  components: {
    zaheader,
    zafooter
  }
};
</script>
<style lang="scss">
@import "@/assets/sass/estilo.sass";
</style>
